import {getBackendErrorMessage} from '../../shared/utils/httpError';
import {extractListPayload} from '../../shared/utils/payload';

export {extractListPayload};

export const getBackendMessage = (error, fallbackMessage) => getBackendErrorMessage(error, fallbackMessage);

const toDateBR = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('pt-BR');
};

const toNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

const getStatus = (item) => item?.status || item?.situacao || 'ATIVA';

export const normalizeLicencaRows = (items = []) => items.map((item) => {
    const plan = item?.plano?.nome_plano || item?.plano?.nome || item?.nome_plano || '-';
    const userLimit = toNumber(
        item?.plano?.max_usuarios
        ?? item?.plano?.usuarios
        ?? item?.usuarios_limite
        ?? item?.limite_usuarios,
        0
    );
    const consumedUsers = toNumber(item?.usuarios_utilizados ?? item?.usuarios_ativos ?? item?.usuarios_em_uso, 0);
    const totalUsers = userLimit;
    const consumption = totalUsers > 0 ? Math.min(100, Math.round((consumedUsers / totalUsers) * 100)) : 0;

    return {
        id: item?.id,
        name: item?.chave_ativacao || item?.codigo || `Licença #${item?.id ?? '-'}`,
        system: item?.sistema?.nome || item?.plano?.sistema?.nome || '-',
        plan,
        status: getStatus(item),
        expiry: toDateBR(item?.validade_fim || item?.data_vencimento),
        users: `${consumedUsers}/${totalUsers || consumedUsers || 0}`,
        consumption,
        tenantId: item?.tenant_id || '-',
        raw: item,
    };
});

export const buildLicencaStats = (rows = []) => {
    const total = rows.length;
    const totalUsersUsed = rows.reduce((acc, row) => acc + Number(row.users.split('/')[0] || 0), 0);
    const totalUsersAvailable = rows.reduce((acc, row) => acc + Number(row.users.split('/')[1] || 0), 0);
    const avgConsumption = total > 0 ? Math.round(rows.reduce((acc, row) => acc + row.consumption, 0) / total) : 0;
    const nextExpiry = rows
        .map((row) => row.raw?.validade_fim || row.raw?.data_vencimento)
        .filter(Boolean)
        .sort()[0];

    return {
        total: String(total),
        users: `${totalUsersUsed}/${totalUsersAvailable}`,
        consumption: `${avgConsumption}%`,
        nextExpiry: nextExpiry ? toDateBR(nextExpiry) : '-',
    };
};


export const normalizePlanoLicenciamento = (payload = {}) => ({
    id: payload?.id || '-',
    systemId: payload?.id_sistema || payload?.sistema?.id || '-',
    systemName: payload?.sistema?.nome || '-',
    internalUse: Boolean(payload?.sistema?.uso_interno),
    name: payload?.nome_plano || '-',
    description: payload?.descricao || '-',
    basePrice: Number(payload?.preco_base_mensal ?? 0),
    addonsAllowed: Boolean(payload?.permite_addons),
    supportIncluded: Boolean(payload?.possui_suporte),
    billingType: payload?.tipo_cobranca || '-',
    status: payload?.status || '-',
    modules: Array.isArray(payload?.modulos) ? payload.modulos.map((moduleItem = {}) => ({
        id: moduleItem?.id || moduleItem?.id_modulo || '-',
        moduleId: moduleItem?.id_modulo || moduleItem?.modulo?.id || '-',
        name: moduleItem?.modulo?.nome || moduleItem?.nome || '-',
        includedByDefault: Boolean(moduleItem?.incluso_por_padrao),
        removable: Boolean(moduleItem?.pode_remover),
        createdAt: moduleItem?.criado_em || null,
        raw: moduleItem,
    })) : [],
    createdAt: payload?.criado_em || null,
    updatedAt: payload?.atualizado_em || null,
    raw: payload,
});

// Data sem hora (`aaaa-mm-dd`) em dd/mm/aaaa, sem passar por `Date`, que a leria em UTC e voltaria um dia.
const toDiaBR = (value) => {
    const [ano, mes, dia] = String(value || '').slice(0, 10).split('-');
    return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

/*
 * Opcionais contratados da assinatura (BBF-4), de `GET /licencas/{id}/opcionais`: o nome vem da versão do plano, e
 * `leavesOn` é o último dia de quem teve a saída agendada para a virada do ciclo.
 */
export const normalizeOpcionaisContratados = (response) => {
    const payload = response?.data?.valor ?? response?.data?.data ?? response?.data ?? {};
    return (Array.isArray(payload?.contratados) ? payload.contratados : []).map((item = {}) => ({
        moduleId: item?.id_modulo || '-',
        name: item?.nome || 'Módulo',
        leavesOn: toDiaBR(item?.sai_apos),
    }));
};
